import { Controller } from "@hotwired/stimulus"

// Keeps .is-active on the correct sidebar link when the URL is advanced by Turbo
// (workspace frame is inside the shell; the sidebar does not re-render).
//
// When multiple sidebar links share the same path but use a query parameter to
// distinguish tabs (e.g. ?search_settings_tab=settings vs unspecified meaning the
// default tab), the link whose query exactly matches the current URL wins. A
// link with no query is treated as the default-tab fallback.
const DISCRIMINATOR_QUERY_KEYS = ["search_settings_tab"]

export default class extends Controller {
  connect() {
    this.boundSync = this.sync.bind(this)
    document.addEventListener("turbo:load", this.boundSync)
    document.addEventListener("turbo:frame-load", this.boundOnFrameLoad)
    this.sync()
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.boundSync)
    document.removeEventListener("turbo:frame-load", this.boundOnFrameLoad)
  }

  boundOnFrameLoad = (event) => {
    if (event.target.id === "admin-workspace") {
      this.sync()
    }
  }

  sync() {
    const pathname = window.location.pathname
    const currentParams = new URLSearchParams(window.location.search)
    const links = this.element.querySelectorAll("a.admin-dashboard__sidebar-link")

    links.forEach((a) => a.classList.remove("is-active"))

    let best = null
    let bestScore = -1

    links.forEach((a) => {
      if (a.target === "_blank") return
      const href = a.getAttribute("href")
      if (!href) return

      let url
      try {
        url = new URL(href, window.location.origin)
      } catch {
        return
      }

      const linkPath = url.pathname
      const pathMatch = pathname === linkPath || pathname.startsWith(`${linkPath}/`)
      if (!pathMatch) return

      const discriminator = discriminatorMatch(url.searchParams, currentParams)
      if (discriminator === null) return

      const score = linkPath.length * 10 + discriminator
      if (score > bestScore) {
        bestScore = score
        best = a
      }
    })

    if (best) best.classList.add("is-active")
  }
}

function discriminatorMatch(linkParams, currentParams) {
  let score = 0
  for (const key of DISCRIMINATOR_QUERY_KEYS) {
    const linkValue = linkParams.get(key)
    const currentValue = currentParams.get(key)
    if (linkValue == null) continue
    if (linkValue === currentValue) {
      score += 1
    } else {
      return null
    }
  }
  return score
}
